export const SET_SETTINGS = 'SET_SETTINGS';

export const changeSettings = (settings) => {
    return dispatch => {
        dispatch({
            type: SET_SETTINGS,
            payload: { settings }
        })
    }
}
